var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.show
      ? _c("div", { staticClass: "countdown my-1" }, [
          _vm._v("\n    Bestellen Sie in den nächsten: "),
          _c("b", [
            _vm._v(
              _vm._s(_vm.hours) +
                " Stunden " +
                _vm._s(_vm.minutes) +
                "  Minuten"
            )
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "Dann versenden wir die Ware bei sofortiger Zahlung noch Heute.\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }